var exports = {
  "T": "FeaturesTable__srOnly__m1abE_",
};

module.exports = exports;
